import React, { useEffect, useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import { Box, Tooltip } from '@mui/material'
import { useStyles } from '../Pathologist/inboxStyles'
import { TabPanelProps } from '../../../interfaces/inbox'
import DispatchLogistics from './DispatchLogistics'
import ReadyForPickup from './ReadyForPickup'
import InProgress from './InProgress'
import Complete from './Complete'
import { getInProgressData, getCompleteData, getDispatchData, getReadyForPickupData } from '../../../actions'
import { ReceiveSlides } from './../../HOC/ReceiveSlides'
import { SendSlides } from './../../HOC/SendSlides'
import { dropDownUser } from './../../../interfaces/common'
import { LoadBalancer } from './../../HOC/LoadBalancer'

function a11yProps(index: unknown) {
  return {
    id: `case-worklist-${index}`,
    'aria-controls': `case-worklist-${index}`,
  }
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`case-worklist-${index}`}
      aria-labelledby={`case-worklist-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0} pt={1}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

export function Logistics({ user }): JSX.Element {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [value, setValue] = useState(0)
  const [sendSlides, setSendSlides] = useState(true)
  const [receiveSlides, setReceiveSlides] = useState(false)
  const [userInfo, setUserInfo] = useState<dropDownUser | null>(null)
  const [onTrfSearch, setOnTrfSearch] = useState(false)
  const [tabChanged, setTabChanged] = useState(0)
  const [loadBalancer, setLoadBalancer] = useState(true)
  const gridPageSize = 10
  const [isPagination, setIsPagination] = useState(false)

  useEffect(() => {
    if (value === 0) {
      dispatch(
        getReadyForPickupData({
          id: `${user}`,
          pageIndex: 1,
          pageSize: gridPageSize,
          filterField: 'created_datetime',
          filterValue: null,
          caseView: 'ready_for_pickup',
          startDate: null,
          endDate: null,
          sortOrder: 'asc',
          sortField: 'case_number',
        }),
      )
    }
    if (value === 1) {
      dispatch(
        getDispatchData({
          id: `${user}`,
          pageIndex: 1,
          pageSize: gridPageSize,
          filterField: 'created_datetime',
          filterValue: null,
          caseView: 'dispatch',
          startDate: null,
          endDate: null,
          sortOrder: 'asc',
          sortField: 'case_number',
        }),
      )
    }
    if (value === 2) {
      dispatch(
        getInProgressData({
          id: `${user}`,
          pageIndex: 1,
          pageSize: gridPageSize,
          filterField: 'created_datetime',
          filterValue: null,
          caseView: 'in_progress',
          startDate: null,
          endDate: null,
          sortOrder: 'asc',
          sortField: 'case_number',
        }),
      )
    }
    if (value === 3) {
      dispatch(
        getCompleteData({
          id: `${user}`,
          pageIndex: 1,
          pageSize: gridPageSize,
          filterField: 'updated_datetime',
          filterValue: null,
          caseView: 'completed',
          startDate: null,
          endDate: null,
          sortOrder: 'desc',
          sortField: 'case_number',
        }),
      )
    }
  }, [dispatch, user, value])

  const handleChange = (event, newValue: number) => {
    if (newValue === undefined) return
    setValue(newValue)
    setIsPagination(false)
    setUserInfo(null)
  }

  useEffect(() => {
    handleReceiveSlides()
  }, [])

  function handleSendSlides() {
    setLoadBalancer(false)
    setSendSlides(true)
    setReceiveSlides(false)
  }

  function handleReceiveSlides() {
    setLoadBalancer(true)
    setSendSlides(false)
    setReceiveSlides(true)
  }

  function handleNoSlides() {
    setLoadBalancer(false)
    setSendSlides(false)
    setReceiveSlides(false)
  }

  const onSearch = useCallback(
    (val) => {
      setOnTrfSearch(true)
      setTabChanged(value)
      handleChange(null, 5)
      setSendSlides(false)
      setReceiveSlides(false)
    },
    [onTrfSearch, value, tabChanged],
  )

  function clearSearch() {
    handleChange(null, tabChanged)
    setSendSlides(true)
    setReceiveSlides(true)
  }

  return (
    <div>
      <Box className={classes.mt}>
        <AppBar position="static" className={classes.appBar}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="case-worklist"
            classes={{
              indicator: classes.indicator,
            }}
          >
            <Tab
              label="Ready for Pickup "
              {...a11yProps(0)}
              onClick={handleReceiveSlides}
              style={{ margin: '0px 10px' }}
            />
            <Tab label="Dispatch" {...a11yProps(1)} onClick={handleSendSlides} style={{ margin: '0px 10px' }} />
            <Tab label="In progress " {...a11yProps(2)} onClick={handleNoSlides} style={{ margin: '0px 10px' }} />
            <Tab label="Completed " {...a11yProps(3)} onClick={handleNoSlides} style={{ margin: '0px 10px' }} />
            {onTrfSearch && (
              <Tab label="" {...a11yProps(4)} style={{ margin: '0px', minWidth: '0px', padding: '0px' }} />
            )}
            <div className={classes.loadBalancer}>
              {sendSlides && <SendSlides userId={user} setUserInfo={setUserInfo} />}
              {receiveSlides && <ReceiveSlides userId={user} />}
              {loadBalancer && <LoadBalancer user={user} />}
            </div>
          </Tabs>
        </AppBar>
        {/* {value > 0 && value !== 5 && <UserBanner updateUserView={updateUserView} userInfo={userInfo} />} */}
        <TabPanel value={value} index={0}>
          <ReadyForPickup userId={user} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <DispatchLogistics setUserInfo={setUserInfo} userId={user} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <InProgress userId={user} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <Complete userId={user} />
        </TabPanel>
      </Box>
    </div>
  )
}
